(function($){
    $(window).scroll(function(){
        if($(this).scrollTop() > 150) {
            $('header.fixed').html($('header.static').html());
            $('header.fixed').slideDown(500);
        }
        else{
            $('header.fixed').slideUp(500);
        }
    });

    $('body.home').on('click', 'header.static a:not(.open-menu), header.fixed a:not(.open-menu)', function(e){
        if($(this).attr('href').indexOf('#') > -1){
            e.preventDefault();
            var url = $(this).attr('href').replace('/', '');
            $("html, body").animate({
                scrollTop: $(url).offset().top - 120
            }, 1000);
        }
    })
    if(window.location.hash){
        $("html, body").animate({
            scrollTop: $(window.location.hash).offset().top - 120
        }, 1000);
    }
    $('body').on('click', 'header .open-menu', function(e){
        e.preventDefault();
        $('.fullscreen-menu').slideDown(500);
    })
    $('body.home').on('click', '.fullscreen-menu a', function(e){
        $('.fullscreen-menu').slideUp(500);
        if($(this).attr('href').indexOf('#') > -1 && !$(this).hasClass('close-menu')){
            e.preventDefault();
            var url = $(this).attr('href').replace('/', '');
            $("html, body").animate({
                scrollTop: $(url).offset().top - 120
            }, 1000);
        }
    })

})(jQuery)